import req from '../lib/req';

export function findById(id) {
  return req.get(`/xroad/arireg/${id}`);
}
